"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 6a1.5 1.5 0 0 0-1.5 1.5v3h5.046c1.305 0 2.318-1.033 2.318-2.25S13.85 6 12.546 6zm7.914 5.246c.598-.847.95-1.878.95-2.996 0-2.925-2.407-5.25-5.318-5.25H9a4.5 4.5 0 0 0-4.5 4.5v9A4.5 4.5 0 0 0 9 21h5.182c2.911 0 5.318-2.325 5.318-5.25 0-1.925-1.043-3.59-2.586-4.504M7.5 13.5v3A1.5 1.5 0 0 0 9 18h5.182c1.306 0 2.318-1.033 2.318-2.25s-1.012-2.25-2.318-2.25z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BoldIcon24.js.map